/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import * as types from './mutation-types';
import ApiService from '@/services/commonApi';
import { MYPROJECTS, MYACTIVITY, MYPAYMENTS } from '@/utils/endpoint';

const store = ({ commit }, payload) => {
  commit(types.STORE, payload);
};

const getMyProjects = ({ commit }) => {
  ApiService.get(MYPROJECTS)
    .then((response) => {
      commit(types.MYPROJECTS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getMyPayments = ({ commit }) => {
  ApiService.get(MYPAYMENTS)
    .then((response) => {
      commit(types.MYPAYMENTS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getMyActivity = ({ commit }) => {
  ApiService.get(MYACTIVITY)
    .then((response) => {
      commit(types.MYACTIVITY, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const resetToDefaultState = ({ commit }) => {
  commit(types.RESET);
};

export default {
  store,
  getMyProjects,
  getMyActivity,
  getMyPayments,
  resetToDefaultState,
};




// WEBPACK FOOTER //
// ./src/store/modules/account/actions.js